/*
 * ITG: redirect product pages to the region-matching twin.
 *
 * Problem it solves: mainland twin products live at a different URL
 * (handle ends with "-es") than their canary originals. When a visitor
 * lands on the canary URL but their region is mainland (or vice versa),
 * they see the wrong-region version — wrong price, wrong region messages.
 *
 * Fix: on any /products/<handle> load, compare handle suffix to region:
 *   - handle ends "-es"  AND region is mainland   -> stay (correct)
 *   - handle ends "-es"  AND region is canary     -> redirect to non-es
 *   - no "-es" suffix    AND region is mainland   -> redirect to -es
 *   - no "-es" suffix    AND region is canary     -> stay (correct)
 *
 * Runs synchronously in <head> so no visible flash of the wrong-region
 * product page.
 *
 * Caveat: if the target twin doesn't exist (some products don't have
 * a paired version), the redirect leads to a 404. This is rare and
 * accepted — an admin follow-up should create the missing twin. A 404
 * doesn't loop because Shopify's 404 page doesn't sit at /products/<h>.
 *
 * Skips redirect when:
 *   - path is not /products/<handle>
 *   - path has a nested sub-segment
 */
(function () {
  try {
    var path = window.location.pathname;
    if (!path) return;

    // Match /products/<handle> anywhere in the path. Shopify serves
    // product pages under multiple prefixes:
    //   /products/<handle>
    //   /collections/<c>/products/<handle>
    //   /<market-locale>/products/<handle>
    //   /<market-locale>/collections/<c>/products/<handle>
    // Swapping the handle in-place preserves whatever prefix Shopify used.
    var match = path.match(/\/products\/([^\/?#]+)/);
    if (!match) return;
    var afterProducts = match[1];
    if (!afterProducts) return;

    // Read region — order of preference:
    //   1. <html data-itg-region> set by the inline head script from
    //      cart.attributes (server-rendered, authoritative for this
    //      Shopify session) OR from localStorage as a fallback.
    //   2. localStorage directly (redundant but defensive).
    //   3. Theme default 'canarias'.
    //
    // The inline head script in layout/theme.liquid renders
    // <html data-itg-region> from cart.attributes.itg_region first
    // (via the Liquid default), then overrides from localStorage if
    // present. So by the time this script runs, the html attribute is
    // already the best-available answer.
    var region = null;
    try {
      region = document.documentElement && document.documentElement.dataset && document.documentElement.dataset.itgRegion;
    } catch (e) {}
    if (region !== 'canarias' && region !== 'mainland') {
      try { region = localStorage.getItem('itg_region'); } catch (e) {}
    }
    if (region !== 'canarias' && region !== 'mainland') region = 'canarias';

    var endsWithEs = /-es$/.test(afterProducts);
    var shouldBeEs = region === 'mainland';

    // Correct match — no redirect needed.
    if (shouldBeEs === endsWithEs) return;

    var newHandle;
    if (shouldBeEs && !endsWithEs) {
      newHandle = afterProducts + '-es';
    } else if (!shouldBeEs && endsWithEs) {
      newHandle = afterProducts.replace(/-es$/, '');
    } else {
      return;
    }

    var newPath = path.replace(/\/products\/[^\/?#]+/, '/products/' + newHandle);
    var newUrl = newPath + window.location.search + window.location.hash;

    // Verify the twin exists before redirecting. Some products only exist
    // in one region (foreign-language imports without a mainland-market
    // twin). Redirecting blindly dumps the customer on a 404. We use a
    // synchronous XHR HEAD here — this script runs in the <head> before
    // paint, so a 200-400ms blocking check is acceptable; the alternative
    // (async fetch) would flash the wrong-region page for a moment first.
    try {
      var xhr = new XMLHttpRequest();
      xhr.open('HEAD', newPath, false); // synchronous
      xhr.timeout = 2500;
      xhr.send();
      // 404 → twin doesn't exist, stay put.
      if (xhr.status === 404) return;
    } catch (e) { /* network error — err on the side of attempting */ }

    window.location.replace(newUrl);
  } catch (e) { /* fail silent — user sees wrong-region product page */ }
})();
